import React from "react";
import ContractProposalListForm from "./ContractProposalListForm";
import { useState, useEffect } from "react";
import {
    deleteContractProposal,
    getContractProposalList,
    getContractTypeCounters,
} from "../../api/ContractProposalApi";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getCareerLevels } from "../../api/EmployeeApi";
import { getContractTypes } from "../../api/EmployeeApi";
import { appTitle } from "../common/GeneralConfigurations";
import AdnMessageSuccess from "../common/adnMessage/AdnMessageSuccess";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import { AppRoutes } from "../../AppRoutes";

const ManageContractProposalListPage = () => {
    const [searchParams] = useSearchParams();

    const managerName = searchParams.get("managerName")
        ? searchParams.get("managerName")
        : "";
    const contractProposalMonth = searchParams.get("month")
        ? searchParams.get("month")
        : "";
    const contractProposalYear = searchParams.get("year")
        ? searchParams.get("year")
        : "";
    const searchContractTypeId = searchParams.get("contractTypeId")
        ? parseInt(searchParams.get("contractTypeId"))
        : "";

    const [contracts, setContracts] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [orderBy, setOrderBy] = useState("");
    const [contractTypeId, setContractTypeId] = useState(searchContractTypeId);
    const [carrearLevelId, setCarrearLevelId] = useState("");
    const [searchName, setSearchName] = useState("");
    const [searchManagerName, setSearchManagerName] = useState(managerName);
    const [searchOptions, setSearchOptions] = useState([]);
    const [searchManagerOptions, setSearchManagerOptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [careerLevel, setCareerLevelList] = useState([]);
    const [contractTypes, setContractTypes] = useState([]);
    const [contractTypesCounters, setContractTypesCounters] = useState([]);
    const [month, setMonth] = useState(contractProposalMonth);
    const [year, setYear] = useState(contractProposalYear);
    const navigate = useNavigate();

    useEffect(() => {
        document.title = `${appTitle} - Financial Proposals`;

        navigate(AppRoutes.contractProposalList.path);
    }, []);

    useEffect(async () => {
        await loadContractTypeCounters();
    }, [month, year]);

    useEffect(async () => {
        if (searchContractTypeId != "") {
            await getContractProposalList(
                searchName,
                searchManagerName,
                orderBy,
                searchContractTypeId,
                carrearLevelId,
                month,
                year
            ).then((res) => {
                res.data.result.forEach((element) => {
                    if (element.createdAt !== null) {
                        element.createdAt = JSON.stringify(element.createdAt).substring(
                            1,
                            11
                        );
                    }
                    if (element.startDate !== null) {
                        element.startDate = JSON.stringify(element.startDate).substring(
                            1,
                            11
                        );
                    }

                    searchName.length >= 3
                        ? setSearchOptions(res.data.result)
                        : setSearchOptions([]);

                    searchManagerName.length >= 3
                        ? setSearchManagerOptions(res.data.result)
                        : setSearchManagerOptions([]);
                });

                setContractTypeId(searchContractTypeId);
                setContracts(res.data.result);
                setTotalRecords(res.data.totalRecords);
            });
        }
    }, [searchContractTypeId]);

    useEffect(async () => {
        await getContracts();
        carrearoptions();
        contractoptions();
    }, [
        searchName,
        searchManagerName,
        orderBy,
        contractTypeId,
        carrearLevelId,
        month,
        year,
    ]);

    useEffect(() => {
        changeContractNameList();
        changeManagerNameList();
    }, [contracts]);

    const loadContractTypeCounters = async () => {
        await getContractTypeCounters(month, year).then((res) => {
            if (res.status === 200) {
                setContractTypesCounters(res.data.contractProposalsContractTypes);
            }
        });
    };

    const getContracts = async () => {
        await getContractProposalList(
            searchName,
            searchManagerName,
            orderBy,
            contractTypeId,
            carrearLevelId,
            month,
            year
        ).then((res) => {
            res.data.result.forEach((element) => {
                if (element.createdAt !== null) {
                    element.createdAt = JSON.stringify(element.createdAt).substring(
                        1,
                        11
                    );
                }
                if (element.startDate !== null) {
                    element.startDate = JSON.stringify(element.startDate).substring(
                        1,
                        11
                    );
                }

                searchName.length >= 3
                    ? setSearchOptions(res.data.result)
                    : setSearchOptions([]);

                searchManagerName.length >= 3
                    ? setSearchManagerOptions(res.data.result)
                    : setSearchManagerOptions([]);
            });
            setLoading(false);
            setContracts(res.data.result);
            setTotalRecords(res.data.totalRecords);
        });
    };

    const changeContractNameList = () => {
        if (searchName.length >= 3) {
            const optionValues = [];
            setSearchOptions(
                contracts
                    .map((e) => {
                        if (!optionValues.includes(e.name)) {
                            optionValues.push(e.name);
                            return { id: e.name };
                        }
                    })
                    .filter((e) => e !== undefined)
            );
        } else {
            setSearchOptions([]);
        }
    };

    const changeManagerNameList = () => {
        if (searchManagerName.length >= 3) {
            const optionValues = [];
            setSearchManagerOptions(
                contracts
                    .map((e) => {
                        if (!optionValues.includes(e.managerName)) {
                            optionValues.push(e.managerName);
                            return { id: e.managerName };
                        }
                    })
                    .filter((e) => e !== undefined)
            );
        } else {
            setSearchManagerOptions([]);
        }
    };

    const handleSearch = (value) => {
        value.length >= 3 ? setSearchName(value) : setSearchName("");
    };

    const handleSelect = (value) => {
        setSearchName(value);
    };

    const handleManagerSearch = (value) => {
        value.length >= 3 ? setSearchManagerName(value) : setSearchManagerName("");
    };

    const handleManagerSelect = (value) => {
        setSearchManagerName(value);
    };

    const handleContractTypeChange = (value) => {
        if (!value) {
            setContractTypeId("");
        } else {
            setContractTypeId(value);
        }
    };

    const handleCareerLevelChange = (value) => {
        if (!value) {
            setCarrearLevelId("");
        } else {
            setCarrearLevelId(value);
        }
    };

    const handleOrderList = (pag, filter, sorter) => {
        sorter.order === "descend"
            ? setOrderBy("-" + sorter.field)
            : setOrderBy(sorter.field);
    };

    const addContractProposal = () => {
        navigate(AppRoutes.contractProposal.path);
    };

    const carrearoptions = async () => {
        await getCareerLevels().then((res) => {
            setCareerLevelList(res.data);
        });
    };

    const contractoptions = async () => {
        await getContractTypes().then((res) => {
            setContractTypes(res.data);
        });
    };

    const handleDelete = async (id) => {
        const res = await deleteContractProposal(id);
        if (res.status == 200) {
            getContracts();
            await loadContractTypeCounters();
            AdnMessageSuccess();
        } else {
            AdnMessageError();
        }
    };

    const monthHandleChange = (value) => {
        if (value != undefined) {
            setMonth(value);
        } else {
            setMonth("");
        }
    };

    const yearHandleChange = (value) => {
        if (value != undefined) {
            setYear(value);
        } else {
            setYear("");
        }
    };

    return (
        <ContractProposalListForm
            contracts={contracts}
            handleOrderList={handleOrderList}
            totalRecords={totalRecords}
            addContractProposal={addContractProposal}
            handleSearch={handleSearch}
            handleSelect={handleSelect}
            handleManagerSearch={handleManagerSearch}
            handleManagerSelect={handleManagerSelect}
            monthHandleChange={monthHandleChange}
            yearHandleChange={yearHandleChange}
            searchOptions={searchOptions}
            searchManagerOptions={searchManagerOptions}
            searchManagerName={searchManagerName}
            careerLevel={careerLevel}
            contractTypes={contractTypes}
            handleContractTypeChange={handleContractTypeChange}
            handleCareerLevelChange={handleCareerLevelChange}
            loading={loading}
            handleDelete={handleDelete}
            contractTypeId={contractTypeId}
            month={month}
            year={year}
            contractTypesCounters={contractTypesCounters}
        />
    );
};

export default ManageContractProposalListPage;
